import { Typography, Button } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Plus } from '@ui/components/icons';
import { FC } from 'react';

import { CreateEmployeesProfileDrawer } from '../create-employees-profile-drawer/create-employees-profile-drawer';

export const EmployeesProfileHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center mb-4">
      <Typography variant="h300" element="h1">
        {t('EMPLOYEE_PROFILES.TITLE')}
      </Typography>

      <HasPermission permissionFeature="EMPLOYEES_PROFILE_CREATE_PROFILE" permissionType="WRITE">
        <CreateEmployeesProfileDrawer>
          <Button variant="primary">
            <Plus />
            {t('EMPLOYEE_PROFILES.CREATE_PROFILE')}
          </Button>
        </CreateEmployeesProfileDrawer>
      </HasPermission>
    </div>
  );
};
